export function NotAvailableBackground({ src }: { src: string }) {
  return (
    <div className="relative px-[25px] pt-5">
      <img
        className="select-none blur-md"
        src={src}
        alt="Logo"
      />
    </div>
  );
}
